import { useState } from 'react';
import { auth } from '../firebaseConfig';
import { useLoginStore } from '../zustand/StoreAuth/store';
import { User } from '../@types/types';
import { toast } from 'react-toastify';
import { getFirestore, query, where, collection, getDocs, setDoc, doc } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import ReactPixel from 'react-facebook-pixel';

const db = getFirestore();

export function useManualSignUp() {
    const [error, setError] = useState<Error | null>(null);
    const { setUserInfo } = useLoginStore();
    const { t } = useTranslation();

    const signUpWithEmail = async (email: string, password: string, name: string) => {
        try {
            setError(null);

            // Verificar se o email já está registrado no Firestore
            const userQuery = query(collection(db, 'users'), where('email', '==', email));
            const querySnapshot = await getDocs(userQuery);

            if (!querySnapshot.empty) {
                // Email já está em uso, recuperar informações do usuário
                const userData = querySnapshot.docs[0].data() as User;
                setUserInfo(userData);
                localStorage.setItem('userInfo', JSON.stringify(userData));
                toast.success(t('toast_success_user_found'));
            } else {
                // Criar nova conta
                const result = await createUserWithEmailAndPassword(auth, email, password);
                const firebaseUser = result.user;

                const userInfo: User = {
                    id: firebaseUser.uid,
                    token: await firebaseUser.getIdToken(),
                    name: name,
                    isAdmin: false,
                    email: firebaseUser.email || '',
                    photo_url: firebaseUser.photoURL || '',
                    weight: 0,
                    height: 0,
                    imc: 0,
                    bodyFatPercentage: 0,
                    goal: 0,
                    idealWeight: ''
                };

                // Criar um novo documento de usuário no Firestore
                await setDoc(doc(db, 'users', firebaseUser.uid), {
                    ...userInfo,
                    createdAt: new Date(),
                });

                setUserInfo(userInfo);
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                ReactPixel.track('register', { action: 'cadastro' });
                toast.success(t('toast_success_account_created'));
            }
        } catch (error: any) {
            console.error('Erro ao criar conta:', error);
            toast.error(t('toast_error_create_account', { errorMessage: error.message }));
            setError(error);
        }
    };

    return {
        error,
        signUpWithEmail
    };
}
